var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4967 30.1486C24.065 30.1486 30.2004 24.0133 30.2004 16.4449C30.2004 8.87657 24.065 2.74121 16.4967 2.74121C8.92833 2.74121 2.79297 8.87657 2.79297 16.4449C2.79297 24.0133 8.92833 30.1486 16.4967 30.1486Z",
    fill: "#181717",
    stroke: "#181717",
    strokeWidth: 2.74074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4967 30.1486C24.065 30.1486 30.2004 24.0133 30.2004 16.4449C30.2004 8.87657 24.065 2.74121 16.4967 2.74121C8.92833 2.74121 2.79297 8.87657 2.79297 16.4449C2.79297 24.0133 8.92833 30.1486 16.4967 30.1486Z",
    fill: "#181717",
    stroke: "#181717",
    strokeWidth: 2.74074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9688 15.7497C14.429 15.7497 14.8021 15.3766 14.8021 14.9163V12.5413C14.8021 11.7125 15.1313 10.9177 15.7174 10.3316C16.3034 9.74558 17.0983 9.41634 17.9271 9.41634H19.4688V10.9163H17.9271C17.4961 10.9163 17.0828 11.0875 16.778 11.3923L17.3673 11.9815L16.778 11.3923C16.4733 11.697 16.3021 12.1104 16.3021 12.5413V14.9163C16.3021 15.3766 16.6752 15.7497 17.1354 15.7497H19.2348L18.8598 17.2497H17.1354C16.6752 17.2497 16.3021 17.6228 16.3021 18.083V23.583H14.8021V18.083C14.8021 17.6228 14.429 17.2497 13.9688 17.2497H12.4271V15.7497H13.9688Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0693e0450db042db16dddc65df191ae0.svg";
export { ForwardRef as ReactComponent };